<template>
    <div id="followup">
        <template v-if="cantAccessPageFollowup === true">
            <div class="container-fluid xyz">
                <div :class="'page-header-top-container'+titleMargin">
                    <div class="page-name color-71aa3f">{{followupPageData.pageTitle}}</div>
                    <template v-for="(permission, index) in permissionsFollowup">
                        <button title="Export" v-if="permission.name == 'can_export_followup_data'" type="button" id='exportFollowup' class="btn general-button btn-primary icon-btn"
                                v-on:click="exportFollowup($event)">
                            <i class="fa fa-cloud-download" aria-hidden="true"></i>
                        </button>
                    </template>
                    <div class="btn-group pull-right">
                        <button type="button" class="btn_all_followup btn general-button btn-primary" v-on:click="allClick()">All</button>
                        <button type="button" class="btn_my_followup btn general-button btn-secondary" v-on:click="myClick()">My Self</button>
                    </div>
                </div>
                <div class="admin-page-content">
                    <div class="app-filter-good-table-container">
                        <vue-good-table class="followupTable"
                                        ref="listFollowupTable"
                                        mode="remote"
                                        title="Followup"
                                        @on-page-change="onPageChangeFollowup"
                                        @on-selected-rows-change="selectionChangedFollowup"
                                        @on-column-filter="onColumnFilterFollowup"
                                        @on-sort-change="onSortChangeFollowup"
                                        :totalRows="totalRecordsFollowup"
                                        :columns="columnsFollowup"
                                        :rows="rowsFollowup"
                                        :pagination-options="{
                                        enabled: true,
                                        mode: 'pages',
                                        pageLabel: 'Page',
                                        position: 'bottom',
                                        perPage: serverParamsFollowup.perPage,
                                        setCurrentPage: serverParamsFollowup.setCurrentPage,
                                        perPageDropdown: serverParamsFollowup.perPageDropdown,
                                        dropdownAllowAll: false,
                                        }"
                                        :select-options="{
                                        enabled: true,
                                        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                        selectionInfoClass: 'custom-class',
                                        selectionText: 'rows selected',
                                        clearSelectionText: 'clear',
                                        }"
                                        :search-options="{
                                        enabled: false,

                                        }"
                                        >
                                        <template slot="pagination-bottom" slot-scope="props">
                                <div class="vgt-wrap__footer crm" v-if="totalRecordsFollowup > 0">
                                    <div  class="row">
                                        <div class="col-sm-12 col-md-2 PerPage">
                                            <v-select title="Select Per Page"
                                                      v-model="serverParamsFollowup.perPage"
                                                      @input="changedValueFollowupCustomPerPageFollowup()"
                                                      name="customPerPage"
                                                      id="customPerPage"
                                                      label="text"
                                                      :clearable="false"
                                                      :searchable="false"
                                                      :filterable="false"
                                                      :options="serverParamsFollowup.perPageDropdown"
                                                      placeholder="Select Per Page">
                                            </v-select>
                                        </div>
                                        <div class="mt-2 col-sm-12 col-md-2 RowsDisplay">
                                            <p class="pageRowCount">{{paginationDisplayRowsFollowup}} of {{totalRecordsFollowup}}</p>
                                        </div>
                                        <div class="col-sm-12 col-md-6 Pagination">
                                            <ul class="pagination">
                                                <li class="page-item FirstPage" title="First Page">
                                                    <template v-if="Number(serverParamsFollowup.page) == 1">
                                                        <a class="page-link" href="javascript:void(0)">1</a>
                                                    </template>
                                                    <template v-else>
                                                        <a v-on:click="onPerticularPageClickFollowup(1)" class="page-link" href="javascript:void(0)">1</a>
                                                    </template>
                                                </li>
                                                <li class="page-item PreviousPage" title="Previous Page">
                                                    <template v-if="Number(serverParamsFollowup.page) == 1">
                                                        <a class="page-link" href="javascript:void(0)" tabindex="-1"><i class="fa fa-angle-left"></i></a>
                                                    </template>
                                                    <template v-else>
                                                        <a class="page-link" href="javascript:void(0)" tabindex="-1" v-on:click="onPerticularPageClickFollowup(Number(serverParamsFollowup.page)-1)" ><i class="fa fa-angle-left"></i></a>
                                                    </template>
                                                </li>
                                                <!--New Implementation-->
                                                <template v-if="pageNumberListFollowup() < displayPageFollowup">
                                                    <template v-for="(n, index) in pageNumberListFollowup()">
                                                        <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParamsFollowup.page)">
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                        <li :title="'Page ' +n" v-on:click="onPerticularPageClickFollowup(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <!--End New Implementation-->
                                                    <template v-if="Number(serverParamsFollowup.page) <= pageCompareFollowup">
                                                        <template v-for="(n, index) in displayPageFollowup">
                                                            <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParamsFollowup.page)">
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                            <li :title="'Page ' +n" v-on:click="onPerticularPageClickFollowup(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                        </template>
                                                    </template>
                                                    <template v-else-if="Number(serverParamsFollowup.page) >= (pageNumberListFollowup() - (pageCompareFollowup-1))">
                                                        <template v-for="(n, index) in pageNumberListFollowup()">
                                                            <template v-if="n > (pageNumberListFollowup() - displayPageFollowup)">
                                                                <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParamsFollowup.page)">
                                                                    <a class="page-link" href="javascript:void(0)">
                                                                        {{n}}
                                                                    </a>
                                                                </li>
                                                                <li :title="'Page ' +n" v-on:click="onPerticularPageClickFollowup(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                    <a class="page-link" href="javascript:void(0)">
                                                                        {{n}}
                                                                    </a>
                                                                </li>
                                                            </template>
                                                        </template>
                                                    </template>
                                                    <template v-else>
                                                        <template v-for="(n, index) in pageNumberListFollowup()" v-if="(n >= (Number(serverParamsFollowup.page) - (pageCompareFollowup -1))) && (n <= (Number(serverParamsFollowup.page) + (pageCompareFollowup -1)))">
                                                            <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParamsFollowup.page)">
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                            <li :title="'Page ' +n" v-on:click="onPerticularPageClickFollowup(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                        </template>
                                                    </template>
                                                </template>
                                                <li class="page-item NextPage" title="Next Page">
                                                    <template v-if="Number(serverParamsFollowup.page) == pageNumberListFollowup()">
                                                        <a class="page-link" href="javascript:void(0)"><i class="fa fa-angle-right"></i></a>
                                                    </template>
                                                    <template v-else>
                                                        <a class="page-link" href="javascript:void(0)" v-on:click="onPerticularPageClickFollowup(Number(serverParamsFollowup.page)+1)"><i class="fa fa-angle-right"></i></a>
                                                    </template>
                                                </li>
                                                <li class="page-item LastPage" title="Last Page">
                                                    <template v-if="Number(serverParamsFollowup.page) == pageNumberListFollowup()">
                                                        <a class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberListFollowup()}}</a>
                                                    </template>
                                                    <template v-else>
                                                        <a v-on:click="onPerticularPageClickFollowup(pageNumberListFollowup())" class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberListFollowup()}}</a>
                                                    </template>
                                                </li>
                                            </ul>
                                        </div>                                
                                        <div class="mt-2 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                            <p class="pageJumpLabel">Page : </p>
                                        </div>
                                        <div class="mt-1 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                            <input @keyup.enter="jumpToPageInFollowup" v-model="jumpToPageFollowup" type="text" class="form-control form-control-sm" name="jumpToPageFollowup" id="jumpToPageFollowup" placeholder="Page">
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template slot="table-row" slot-scope="props" v-for="(row,key) in rowsFollowup">
                                <div :key="key">
                                    <div v-if="props.column.field == 'due_date'">
                                        <span v-if="props.row.status === 'In Progress'">
                                            {{ props.formattedRow[props.column.field] }}
                                        </span>
                                        <span v-else>
                                            -
                                        </span>
                                    </div>
                                    <div v-else-if="props.column.field == 'action'">
                                        <!--class="btn btn-xs general-button btn-primary"-->
                                        <template v-if="permission.name == 'can_add_new_followup'" v-for="(permission, index) in permissionsFollowup">
                                            <div v-html="props.formattedRow[props.column.field]"></div>
                                        </template>
                                    </div>
                                    <div v-else>
                                        {{props.formattedRow[props.column.field]}}
                                    </div>
                                </div>
                            </template>

                            <!--<div slot="selected-row-actions" slot-scope="computed">-->
                            <!--{{computed.selectedRows}}-->
                            <!--<button v-on:click="onDeleteClick">Delete</button>-->
                            <!--</div>-->
                            <template  v-for="(permission, index) in permissionsFollowup">
                                <div slot="selected-row-actions">
                                    <button title='Delete followup' v-if="permission.name == 'can_add_new_followup'" id="deleteFollowupBtn" v-on:click.prevent="onDeleteClick" class="btn general-button btn-success">Delete</button>
                                </div>
                            </template>
                        </vue-good-table>
                    </div>
                </div>
            </div>
            <!-- Default Size -->
            <div class="modal fade" id="FollowupdefaultModal" tabindex="-1" role="dialog">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title" id="defaultModalLabel">Import Followup From Excel</h4>
                        </div>
                        <form class="form-inline" id="importFollowupform" enctype="multipart/form-data">
                            <div class="modal-body">
                                Select Excel File to Import Followup
                                <label class="myLabel btn general-button btn-info m-r-20">
                                    <input type="file" name="excl_file" accept=".xlsx,.xls" id="upload" ref="filesFollowup" v-on:change="handleFilesUpload()"/>
                                    <span>Select File ...</span>
                                </label>
                                <div v-if="filesFollowup[0]" class="alert alert-success mb-0 mt-3 pl-1" role="alert">
                                    <strong>{{ filesFollowup[0].name }}</strong> uploaded succesfully.
                                </div>
                                <div class="form-group">
                                    <label id="errorMsg" class="error"></label><br>
                                </div>
                                <a id ="demourl" href="demoUrl" target="_blank" class="btn general-button btn-info mt-2">
                                    Download Demo
                                </a>
                            </div>
                            <div class="modal-footer">
                                <button type="button" v-on:click="importFollowup($event);" class="btn general-button btn-success">Import</button>
                                <button type="button" class="btn general-button btn-danger" data-dismiss="modal">Close</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="FollowupExportModel" tabindex="-1" role="dialog">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title" id="defaultModalLabel">Import Followup From Excel</h4>
                        </div>
                        <div class="modal-body">
                            Followup's Exported File is ready to download Please click <a type="button" id="downloadButton" target="_blank" href = "" ><label style="cursor: pointer;" class="font-bold col-pink">DOWNLOAD</label></a> to download the file.
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn general-button btn-danger" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="admin-page-content">
                <div class="col-md-12 error-detail-main forms-container">
                    <div class="error-template">
                        <h1>Oops!</h1>
                        <h2>403</h2>
                        <div class="error-details">Sorry!, You don't have permission to access followup.</div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import Vue from 'vue';
    import VueGoodTable from 'vue-good-table';
    import SessioMixin from '../../mixins/sessionmixin';
    import 'vue-good-table/dist/vue-good-table.css';
    import {list_followupUrl} from '../../config';
    import EventBus from '../event-bus';
    import {addFollowup} from '../../config';
    import swal from 'sweetalert2/dist/sweetalert2.js';
    const Swal = require('sweetalert2');

    export default {
        name: "Followupcomponent",
        mixins: [SessioMixin],
        props: {
            followupPageData: '',
        },
        data: () => ({
                titleMargin: '',
                displayPageFollowup: 7,
                pageCompareFollowup: 0,
                paginationDisplayRowsFollowup: '',
                jumpToPageFollowup: 0,

                loginIDFollowup: 0,
                permissionsFollowup: [],
                cantAccessPageFollowup: true,
                messageFollowup: 'all',
                // filteredFlag: false,
                exportFilteredFlagFollowup: false,
                filesFollowup: [],
                isLoggedInFollowup: false,
                firstLoadFollowup: 0,
                columnsFollowup: [
                    {
                        label: 'Created By',
                        field: 'created_first_name',
                        filterable: true,
                        sortable:false,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Created By", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Collector',
                        field: 'user_first_name',
                        filterable: true,
                        sortable:false,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "User Name", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'CusId',
                        field: 'customer_id',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "CusId", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Customer Name',
                        field: 'customer_first_name',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Customer Name", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Subject',
                        field: 'subject',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Subject", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter", //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Due Date',
                        field: 'due_date',
                        filterable: true,
                        // dateInputFormat: 'DD/MM/YYYY HH:mm:ss',
                        dateOutputFormat: 'DD/MM/YYYY HH:mm:ss',
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Due Date", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Status',
                        field: 'status',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Select Status", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: ['In Progress', 'Open', 'Closed'], // dropdown (with selected values) instead of text input
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Category',
                        field: 'category',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Select Category", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [
                            { value: "collector_initial_contact", text: "Collector – Initial Contact" },
                            { value: "collector_follow_up", text: "Collector – Follow Up" },
                            { value: "collector_escalation_to_credit_manager", text: "Collector - Escalation to Credit Manager" },
                            { value: "credit_manager_initial_contact", text: "Credit Manager - Initial Contact" },
                            { value: "ops_branch_account_escalation", text: "OPS/Branch – Account Escalation" },
                            { value: "credit_manager_cod_warning", text: "Credit Manager – COD Warning" },
                            { value: "credit_manager_cod_notification", text: "Credit Manager – COD Notification" },
                            { value: "demand_letter_issued", text: "Demand Letter Issued" },
                            { value: "escalation_to_corporate_credit_manager", text: "Escalation to Corporate Credit Manager" },
                            { value: "account_adjustment", text: "Account Adjustment (Refund/Write Off/Offset)" },
                            { value: "broken_promise_to_pay", text: "Broken Promise to Pay" },
                            { value: "customer_inquiry", text: "Customer Inquiry" },
                            { value: "credit_balance_review", text: "Credit Balance Review" },
                            { value: "credit_override", text: "Credit Override" },
                            { value: "credit_application_requested", text: "Credit Application Requested" },
                            { value: "credit_limit_review_request", text: "Credit Limit Review Request" },
                            { value: "dnc_status", text: "DNC Status (AFDA, Legal, 3rd Party, etc.)" },
                            { value: "dispute", text: "Dispute" },
                            { value: "promise_to_pay", text: "Promise to Pay" },
                            { value: "rebill_request", text: "Rebill Request" },
                            { value: "treasury_notification", text: "Treasury Notification" },
                            { value: "not_responding", text: "Not Responding" },
                            { value: "paid", text: "Paid" },
                            { value: "terms_of_credit", text: "Terms Of Credit" },
                            { value: "other", text: "Other" }
                            ],
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Priority',
                        field: 'priority',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Select Priority", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: ['Low', 'Normal', 'High'], // dropdown (with selected values) instead of text input
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Created Date',
                        field: 'created_at',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Created Date", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Actions',
                        field: 'action',
                        html: true,
                        sortable: false,
                        thClass: 'disable-sorting',
                        width: '106px',
                    }
                ],
                rowsFollowup: [],
                totalRecordsFollowup: 0,
                serverParamsFollowup: {
                    columnFilters: {},
                    sort: {
                        field: 'created_at',
                        type: 'desc',
                    },
                    page: 1,
                    perPage: 25,
                    setCurrentPage: 1,
                    perPageDropdown: [],
                },
            }),
        watch: {
            'serverParamsFollowup.perPage': {
                handler() {
                    this.onPerPageChangeFollowup();
                },
            },
            filesFollowup: function () {
                var self = this;
                if(self.filesFollowup[0]){
                    $("#errorMsg").html('');
                }
            }
        },
        beforeMount: function () {
            var self = this;
            var check = window.localStorage.getItem('api_token');

            if (check != null) {
                self.isLoggedInFollowup = true;
                self.getpermissionsFollowup();

            }
            if (self.followupPageData.cus_id > 0) {
                self.columnsFollowup['1'].filterOptions.enabled = false;
                self.columnsFollowup['2'].filterOptions.enabled = false;
            }
        },
        mounted: function () {
            var app = this;
            if (app.followupPageData.cus_id > 0) {
                app.loadFilters('menufollowupcustomer', app.columnsFollowup, app.serverParamsFollowup, "followupTable");
            } else {
                app.loadFilters('menufollowup', app.columnsFollowup, app.serverParamsFollowup, "followupTable");
            }
            var initial = process.env.ROOT_API;
            var initial = initial.replace('/v1', '');
            $("#demourl").attr("href", initial + '/demo/Followup.xlsx');
            // console.log(this.messageFollowup);
            app.showLoader();
            var userObj = localStorage.getItem('user_obj');
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                this.loginIDFollowup = userJson.id;
                EventBus.$emit("logged-in", false, userJson["first_name"], userJson["last_name"], userJson["email"]);
            }
            this.jumpToPageFollowup = this.serverParamsFollowup.page;
            this.pageCompareFollowup = Math.ceil(this.displayPageFollowup / 2);
            $("#jumpToPageFollowup").on('keyup', function (e) {
                if (e.keyCode === 13) {  //checks whether the pressed key is "Enter"
                    app.jumpToInputPageFollowup(app.jumpToPageFollowup)
                }
            });
            if (app.followupPageData.is_part == 1) {
                app.titleMargin = " pt-0";
            }
            this.serverParamsFollowup.perPage = this.followupPageData.perPage;
            for (var i = this.followupPageData.perPage; i < 100; ) {
                this.serverParamsFollowup.perPageDropdown.push(i);
                if (this.followupPageData.perPage < 5) {
                    i = i * 5;
                } else {
                    i = i * 2;
                }
            }
            this.serverParamsFollowup.perPageDropdown.push(100);
            this.serverParamsFollowup.perPageDropdown.push(200);
            this.serverParamsFollowup.perPageDropdown.push(500);
            /*setTimeout(function () {
             $('.filter-th .vgt-select').addClass("custom-select");
             }, 100);*/
            this.loadFollowupComponent();
        },
        methods: {
            openImportModal: function(){
                var self = this;
                self.$refs.filesFollowup.value = '';
                self.filesFollowup = [];
                $('#FollowupdefaultModal').modal('show');
            },
            /* Custome pagination Methods started */
            /*customPageChange(customCurrentPage) {
             },
             customPerPageChange() {
             },*/
            jumpToPageInFollowup: function (e) {
                let self = this;
                self.jumpToInputPageFollowup(self.jumpToPageFollowup);
            },
            changedValueFollowup: function (value) {
                /*console.log(value);*/
            },
            jumpToInputPageFollowup: function (pageNumber) {
                var self = this;
                var reg = /^\d+$/;
                if (pageNumber <= 0 || pageNumber == '') {
                    pageNumber = 1;
                } else if (pageNumber > self.pageNumberListFollowup()) {
                    pageNumber = self.pageNumberListFollowup();
                    if (pageNumber <= 0 || pageNumber == '') {
                        pageNumber = 1;
                    }
                } else if (!String(self.jumpToPageFollowup).match(reg)) {
                    pageNumber = 1;
                }
                self.onPerticularPageClickFollowup(pageNumber);
            },
            onPerticularPageClickFollowup: function (pageNumber) {
                var self = this;
                self.serverParamsFollowup.page = pageNumber;
                self.jumpToPageFollowup = pageNumber;
                /* Single Backend Call on page load start */
                if(self.firstLoadFollowup != 1 && self.jumpToPageFollowup != 1) {
                    self.loadFollowupComponent();
                } else if(self.firstLoadFollowup == 1 && self.jumpToPageFollowup >=1) {
                    self.loadFollowupComponent();
                }
                /* Single Backend Call on page load end */
            },
            pageNumberListFollowup: function () {
                var self = this;
                var totalRecord = self.totalRecordsFollowup;
                var count = 0;
                for (var i = 0; totalRecord > 0; i++) {
                    totalRecord = totalRecord - self.serverParamsFollowup.perPage;
                    count++;
                }
                return count;
            },
            changedValueFollowupCustomPerPageFollowup: function () {
                var self = this;
                /* Single Backend Call on page load start */
                if(self.firstLoadFollowup != 1) {
                    self.jumpToInputPageFollowup(self.serverParamsFollowup.page);
                    self.loadFollowupComponent();
                }
                /* Single Backend Call on page load end */
            },
            /* Custome pagination Methods End */
            getpermissionsFollowup: function () {
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/user/permission",
                    type: "POST",
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        self.exportFilteredFlagFollowup = false;
                        if (data.status == 'success') {
                            self.cantAccessPageFollowup = false;
                            self.permissionsFollowup = data.content;
                            let current_build = window.localStorage.getItem("build_version");
                            let latest_build = data.build;
                            if (current_build != undefined && current_build == '') {
                                localStorage.setItem("build_version", data.build);
                            } else if (current_build != latest_build) {
                                localStorage.setItem("build_version", data.build);
                                location.reload(true);
                            }
                            if (self.permissionsFollowup.length > 0) {
                                for (var i = 0; i < self.permissionsFollowup.length; i++) {
                                    if (self.permissionsFollowup[i].name == 'can_see_followup_list') {
                                        self.cantAccessPageFollowup = true;
                                    }
                                }
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.cantAccessPageFollowup = false;
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }

                });
            },
            /*formatFn: function (value) {
             return `ITEM ${value}`;
             },*/
            updateParamsFollowup(newProps) {
                this.serverParamsFollowup = Object.assign({}, this.serverParamsFollowup, newProps);
            },
            onPageChangeFollowup(params) {
                this.updateParamsFollowup({page: params.currentPage});

                this.loadFollowupComponent();
            },
            onPerPageChangeFollowup() {
                this.updateParamsFollowup({perPage: this.serverParamsFollowup.perPage});
                this.totalRecordsFollowup = this.totalRecordsFollowup;
                this.loadFollowupComponent();
            },

            onColumnFilterFollowup(params) {
                this.updateParamsFollowup(params);
                {
                    field: ('subject');
                    field: ('due_date');
                    field: ('status');
                    field:('priority');
                    field:('description');
                    field:('cusid');
                    field:('customer_first_name');
                    field:('user_first_name');
                }
                ;
                this.serverParamsFollowup.page = 1;
                var filtersPr = JSON.parse(JSON.stringify(this.serverParamsFollowup));
                var filters = filtersPr.columnFilters;

                if (this.firstLoadFollowup == 1 || filters.subject || filters.due_date || filters.status || filters.priority
                        || filters.description || filters.cusid || filters.customer_first_name || filters.user_first_name || filters.customer_id || filters.created_at || filters.action) {
                    this.filteredFlag = true;
                    this.loadFollowupComponent();
                }

            },
            selectionChangedFollowup() {

                var self = this;
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },
            editFollowup() {

                var self = this;
                // self.$router.push("/addfollowup");
                self.$router.push("/followup/create/" + self.followupPageData.cus_id);
            },
            onSortChangeFollowup(params) {
                this.updateParamsFollowup({
                    sort: {
                        type: params.sortType,
                        field: this.columnsFollowup[params.columnIndex].field,
                        /*type: params[0].type,
                         field: params[0].field,*/
                    },
                });
                this.loadFollowupComponent('sort');
            },
            exportFollowup(e) {
                var self = this;
                self.exportFilteredFlagFollowup = true;
                //console.log(self.exportFilteredFlagFollowup);
                // console.log(self.filteredFlag);
                if (self.exportFilteredFlagFollowup == true) {
                    //console.log("True");
                    self.loadFollowupComponent();
                } else {
                    //console.log("False");
                    //change button 
                    $(e.target).html('<i class="fa fa-cloud-download" aria-hidden="true"></i>...');
                    $(e.target).prop("disabled", true);
                    $.ajax({
                        url: process.env.ROOT_API + "/followup/export",
                        type: "GET",
                        data: {type: 'xlsx'},
                        //processData: false,
                        //contentType: false,
                        dataType: 'json',
                        headers: {
                            'Accept': 'application/json',
                            "Access-Control-Allow-Origin": '*',
                            "Authorization": "Bearer " + localStorage.getItem("api_token"),
                            'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                            "Cache-Control": "no-cache"
                        },
                        success: function (data) {
                            if (data.status == "success") {
                                location.href = data.content.web;
                                /*$("#downloadButton").attr("href", data.content.web);
                                 $('#FollowupExportModel').modal('show');*/
                                $(e.target).html('<i class="fa fa-cloud-download" aria-hidden="true"></i>');
                                $(e.target).prop("disabled", false);
                            } else {
                                $("#errorMsg").html(data.message);
                                if (data.content.length > 0) {
                                    var err = "";
                                    for (var i = 0; i < data.content.length; i++) {
                                        err += data.content[i] + "<br>";
                                    }
                                    $("#errorMsg").html(err);
                                }
                            }

                        },
                        error: function (jqXHR, exception) {
                            if (jqXHR.status == 0) {
                                self.errorMsg = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (jqXHR.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem('user_obj');
                                    localStorage.removeItem('api_token');
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }

                                self.errorMsg = jqXHR.responseJSON.message;
                            }
                        }
                    });
                }

                // self.loadFollowupComponent();
            },
            importFollowup(e) {
                var self = this;
                $(e.target).html('');
                $(e.target).html('Importing...');
                $(e.target).prop("disabled", true);
                var formData = new FormData();
                for (var i = 0; i < self.filesFollowup.length; i++) {
                    let file = self.filesFollowup[0];
                    //console.log(file);
                    formData.append('excl_file', file);
                }
                //console.log(formData);
                $.ajax({
                    url: process.env.ROOT_API + "/followup/import",
                    type: "POST",
                    data: formData,
                    processData: false,
                    contentType: false,
                    dataType: 'json',
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    success: function (data) {

                        if (data.status == "success") {
                            $("#errorMsg").html('');
                            $(e.target).html('');
                            $(e.target).html('Import');
                            $(e.target).prop("disabled", false);
                            /*$("#errorMsg").html(data.message);*/
                            self.loadFollowupComponent();
                            self.hideModel();
                            var messageType = 'success';
                            var messageTitle = 'Success';
                            if (data.import > 0) {
                                messageType = 'success';
                                messageTitle = 'Success';
                            } else {
                                messageType = 'info';
                                messageTitle = 'Warning';
                            }
                            Swal.fire({
                                type: messageType,
                                title: messageTitle,
                                html: data.message + '<br>' + data.messageSkipRecords,
                                showConfirmButton: true,
                            });
                        } else {
                            $(e.target).html('');
                            $(e.target).html('Import');
                            $(e.target).prop("disabled", false);
                            $("#errorMsg").html(data.message);
                            if (data.content.length > 0) {
                                var err = "";
                                for (var i = 0; i < data.content.length; i++) {
                                    err += data.content[i] + "<br>";
                                }
                                $("#errorMsg").html(err);
                            }
                        }

                    },
                    error: function (jqXHR, exception) {
                        $(e.target).html('');
                        $(e.target).html('Import');
                        $(e.target).prop("disabled", false);
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }

                            self.errorMsg = jqXHR.responseJSON.message;
                        }
                    }
                });
                // self.$router.push("/addfollowup");
                //self.$router.push("/followup/create");
            },
            handleFilesUpload: function () {
                /*
                 Get the uploaded filesFollowup from the input.
                 */
                var self = this;
                let uploadedFiles = "";
                uploadedFiles = self.$refs.filesFollowup.files;
                //console.log(uploadedFiles);
                /*
                 Assign the uploaded file to the filesFollowup array
                 */
                /*this.filesFollowup.pop();*/
                for (var i = 0; i < uploadedFiles.length; i++) {
                    self.filesFollowup = [uploadedFiles[i]];
                }
                /*this.getImagePreviews();*/
            },
            hideModel() {
                $('#FollowupdefaultModal').modal('hide');
                return false;
            },
            allClick: function () {
                var self = this;
                self.messageFollowup = 'all';
                self.loadFollowupComponent();
            },
            myClick: function () {
                var self = this;
                self.messageFollowup = 'my';
                self.serverParamsFollowup.page = 1;
                self.jumpToPageFollowup = 1;
                self.loadFollowupComponent();
            },
            loadFollowupComponent: function (flag) {
                var self = this;
                self.serverParamsFollowup.setCurrentPage = self.serverParamsFollowup.page;
                if (self.messageFollowup == 'my') {
                    self.toggleButtons(self.messageFollowup, 'btn_my_followup', 'btn_all_followup');
                } else {
                    self.toggleButtons(self.messageFollowup, 'btn_all_followup', 'btn_my_followup');
                }
                if (self.followupPageData.cus_id > 0) {
                    var fields = {
                        page: self.serverParamsFollowup.page,
                        perPage: self.serverParamsFollowup.perPage,
                        filters: self.serverParamsFollowup.columnFilters,
                        messageData: self.messageFollowup,
                        sort: self.serverParamsFollowup.sort,
                        exportFiltered: self.exportFilteredFlagFollowup,
                        custid: self.followupPageData.cus_id,
                        flag:flag
                    };
                    self.storeFilters('menufollowupcustomer', self.serverParamsFollowup, false);
                } else {
                    var fields = {
                        page: self.serverParamsFollowup.page,
                        perPage: self.serverParamsFollowup.perPage,
                        filters: self.serverParamsFollowup.columnFilters,
                        messageData: self.messageFollowup,
                        sort: self.serverParamsFollowup.sort,
                        exportFiltered: self.exportFilteredFlagFollowup,
                        flag:flag
                    };
                    self.storeFilters('menufollowup', self.serverParamsFollowup, false);
                }
                self.firstLoadFollowup = 1;
                self.showLoader();
                $.ajax({
                    url: process.env.ROOT_API + "/followup/list",
                    type: "GET",
                    data: fields,
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        self.exportFilteredFlagFollowup = false;
                        if (data.message == 'success' || data.message == 'error') {
                            self.rowsFollowup = data.content.row;
                            self.totalRecordsFollowup = data.content.totalRecords;
                            self.showHidePagination("followupTable", self.totalRecordsFollowup);
                            self.filteredFlag = false;
                            self.jumpToPageFollowup = self.serverParamsFollowup.page;
                        }
                        if (data.message == "success export") {
                            //console.log(data.content.web);
                            $('#exportFollowup').html('<i class="fa fa-cloud-download" aria-hidden="true"></i>');
                            $('#exportFollowup').prop("disabled", false);
                            location.href = data.content.web;
                        }
                        self.paginationDisplayRowsFollowup = self.getRecords(self.serverParamsFollowup.page, self.serverParamsFollowup.perPage, self.totalRecordsFollowup);
                        self.hideLoader();
                    },
                    error: function (jqXHR, exception) {
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }

                            self.error = jqXHR.responseJSON.message;
                        }
                        self.hideLoader();
                    }
                });

            },
            onDeleteClick() {
                //console.log("selected rows", self.$refs['listFollowupTable'].selectedRows)
                var self = this;
                var data = self.$refs['listFollowupTable'].selectedRows;
                var use = [];
                for (var i = 0; i < data.length; i++) {
                    use.push(self.$refs['listFollowupTable'].selectedRows[i].id)
                }
                // console.log(use)
                Swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    if (result.value) {
                        Swal.fire(
                                'Deleted!',
                                'Your file has been deleted.',
                                'success'
                                )
                        $("#deleteFollowupBtn").val("Deleting ...");
                        $.ajax({
                            url: process.env.ROOT_API + "/followup/delete",
                            type: "POST",
                            data: 'ids=' + use,
                            headers: {
                                'Accept': 'application/json',
                                "Access-Control-Allow-Origin": '*',
                                "Authorization": "Bearer " + localStorage.getItem("api_token"),
                                'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                                "Cache-Control": "no-cache"
                            },
                            dataType: 'json',
                            success: function (data) {
                                setTimeout(function () {
                                    $(".alert-success").removeClass("show");
                                    $(".alert-success").addClass("hide");
                                }, 5000);
                                setTimeout(function () {
                                    $("#deleteFollowupBtn").val("Delete");
                                }, 10000);
                                self.rowsFollowup = data.content.row;
                                if (data.code == '200') {
                                    // alert("Hii");
                                    self.rowsFollowup = data.content.row;
                                    self.totalRecordsFollowup = data.content.totalRecords;
                                    self.loadFollowupComponent();
                                }
                            },
                            error: function (jqXHR, exception) {
                                if (jqXHR.status == 0) {
                                    self.error = "Remote server can not be reachable";
                                } else {
                                    //redirect to login page if user not authenticated
                                    if (jqXHR.status == 401) {
                                        //clear previous data
                                        localStorage.removeItem('user_obj');
                                        localStorage.removeItem('api_token');
                                        //EventBus.$emit("logged-in", true, "", "");
                                        self.$router.push("/login");
                                    }

                                    self.error = jqXHR.responseJSON.message;
                                }
                            }
                        });
                    }
                });

            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/followup/ListFollowupComponent.vue